/*
 * Helper sub-routine to 'wait' for our login / exchange request
 * to finish, as well as to return the new access token from the store.
*/

import { delay } from 'redux-saga';
import { call, race, select, take } from 'redux-saga/effects';

import { SESSION_FETCH_SUCCESS } from '../modules/session/actions';
import { getLoading } from '../modules/session/getters';

const FIVE_SECONDS = 5000;

function* waitForSession() {
  let loading = yield select(getLoading);

  // wait for our token
  while (loading) {
    yield take(SESSION_FETCH_SUCCESS);
    loading = yield select(getLoading);
  }
}

export default function* () {
  // start a race between waiting for the token, and a 5 second timeout
  // if the timeout wins, we return null
  const { token } = yield race({
    token: call(waitForSession),
    timeout: call(delay, FIVE_SECONDS)
  });

  if (token) {
    return token;
  }

  // timeout won the race
  return null;
}



// WEBPACK FOOTER //
// ./src/lib/wait-for-session.js